/** groups: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "playerSettings": "Player Settings",
  "playerSettingsHint": "Apply to every player in this group, unless a player sets its own. A player in several groups takes each setting from the first group by name.",
  "settingsSaved": "Saved | Saved: sent to the group's player | Saved: sent to the group's {n} players",
  "deleteQ": "Delete “{name}”? Its {n} player leaves the group and the group's content is removed from it. | Delete “{name}”? Its {n} players leave the group and the group's content is removed from them.",
  "removeMemberQ": "Remove “{name}” from this group? It stops playing the group's content.",
  "nContent": "{n} content | {n} content",
  "manageX": "Manage {name}",
  "noMatch": "No group matches “{q}”",
  "nGroups": "{n} player group | {n} player groups",
  "drawerCounts": "{players} · {content}",
  "nPlayers": "{n} player | {n} players",
  "removeFrom": "Remove {name} from the group",
  "page": "page.",
  "alsoIn": "also in {groups}",
  "alreadyIn": "Already in this group",
  "addN": "Add {n} player | Add {n} players",
  "addNone": "Add players",
  "deleteX": "Delete “{name}”",
  "manifestRev": "r{n}",
  "colName": "Group Name",
  "colPlayers": "Players",
  "syncTitle": "Synchronized Playback",
  "syncHint": "If selected, a lead player must be chosen, causing all other players to synchronize their playback loops with the lead player.",
  "syncNeedsTwo": "Add at least two players to this group to synchronize them.",
  "syncLead": "Lead player",
  "leadBadge": "Lead",
  "leadBadgeHint": "Synchronized Playback: every other player in this group plays this player's content, in step with it.",
  "syncChooseLead": "Choose the lead player",
  "syncLeadHint": "Every player in the group plays the lead player's content, switching at the same moments. Shuffle and cycle playlists play in order while synchronized.",
  "syncSave": "Save",
  "syncOnDone": "Synchronized playback turned on",
  "syncOffDone": "Synchronized playback turned off",
  "colTags": "Tags",
  "colContent": "No. Content",
  "colCreated": "Created",
  "newGroup": "New group",
  "title": "Groups",
  "intro": "Content published to a player group plays on every player in it. A player gets the group's content automatically.",
  "searchLabel": "Search player groups",
  "searchPh": "Search groups or tags",
  "manage": "Manage player group",
  "clearSearch": "Clear search",
  "noGroups": "No player groups yet",
  "emptyHint": "Simplify publishing by grouping your players, like every lobby display. A player can be in several groups.",
  "drawerDesc": "Players in a group play the content published to it.",
  "name": "Name",
  "namePh": "e.g. Lobby players",
  "nextHint": "Next you can add players and publish content to it.",
  "rename": "Rename",
  "noMembers": "No players in this group yet.",
  "noCoords": "no coordinates",
  "located": "located",
  "addPlayers": "Add players",
  "allIn": "Every player is already in this group. Add more players on the",
  "notInGroup": "Players not in this group",
  "saveTags": "Save tags",
  "cancel": "Cancel",
  "tagsHint": "Members count as having these tags (Publish → Tags, Restrictions).",
  "deleteGroup": "Delete player group",
  "deleteHint": "Its players leave the group and its published content is removed from them.",
  "createGroup": "Create group",
  "creating": "Creating…"
};
const ar: typeof en = {
  "playerSettings": "إعدادات المشغّل",
  "playerSettingsHint": "تنطبق على كل مشغّل في هذه المجموعة ما لم يحدد المشغّل إعداده الخاص. المشغّل الموجود في عدة مجموعات يأخذ كل إعداد من أول مجموعة حسب الاسم.",
  "settingsSaved": "تم الحفظ | تم الحفظ: أُرسل إلى مشغّل المجموعة | تم الحفظ: أُرسل إلى مشغّلَي المجموعة | تم الحفظ: أُرسل إلى {n} مشغلات | تم الحفظ: أُرسل إلى {n} مشغلًا | تم الحفظ: أُرسل إلى {n} مشغل",
  "deleteQ": "حذف «{name}»؟ لا مشغلات فيها. | حذف «{name}»؟ يغادر مشغلها المجموعة ويُزال محتوى المجموعة منه. | حذف «{name}»؟ يغادر مشغلاها المجموعة ويُزال محتوى المجموعة منهما. | حذف «{name}»؟ تغادر مشغلاتها الـ{n} المجموعة ويُزال محتوى المجموعة منها. | حذف «{name}»؟ يغادر {n} مشغلًا المجموعة ويُزال محتوى المجموعة منها. | حذف «{name}»؟ يغادر {n} مشغل المجموعة ويُزال محتوى المجموعة منها.",
  "removeMemberQ": "إزالة «{name}» من هذه المجموعة؟ سيتوقف عن عرض محتوى المجموعة.",
  "nContent": "لا محتوى | محتوى واحد | محتويان | {n} محتويات | {n} محتوى | {n} محتوى",
  "manageX": "إدارة {name}",
  "noMatch": "لا توجد مجموعة تطابق «{q}»",
  "nGroups": "لا مجموعات | مجموعة مشغلات واحدة | مجموعتا مشغلات | {n} مجموعات مشغلات | {n} مجموعة مشغلات | {n} مجموعة مشغلات",
  "drawerCounts": "{players} · {content}",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "removeFrom": "إزالة {name} من المجموعة",
  "page": ".",
  "alreadyIn": "موجود في هذه المجموعة بالفعل",
  "alsoIn": "موجود أيضًا في {groups}",
  "addN": "إضافة | إضافة مشغل واحد | إضافة مشغلين | إضافة {n} مشغلات | إضافة {n} مشغلًا | إضافة {n} مشغل",
  "addNone": "إضافة مشغلات",
  "deleteX": "حذف «{name}»",
  "manifestRev": "ن{n}",
  "colName": "اسم المجموعة",
  "colPlayers": "المشغلات",
  "syncTitle": "التشغيل المتزامن",
  "syncHint": "عند التحديد يجب اختيار مشغّل رئيسي، فتُزامِن بقية المشغلات حلقات تشغيلها مع المشغّل الرئيسي.",
  "syncNeedsTwo": "أضف مشغّلَين على الأقل إلى هذه المجموعة لمزامنتهما.",
  "syncLead": "المشغّل الرئيسي",
  "leadBadge": "رئيسي",
  "leadBadgeHint": "التشغيل المتزامن: كل مشغّل آخر في هذه المجموعة يعرض محتوى هذا المشغّل، بالتزامن معه.",
  "syncChooseLead": "اختر المشغّل الرئيسي",
  "syncLeadHint": "يعرض كل مشغّل في المجموعة محتوى المشغّل الرئيسي وينتقل في اللحظات نفسها. تُعرض قوائم التشغيل العشوائية والدورية بالترتيب أثناء المزامنة.",
  "syncSave": "حفظ",
  "syncOnDone": "تم تشغيل التشغيل المتزامن",
  "syncOffDone": "تم إيقاف التشغيل المتزامن",
  "colTags": "الوسوم",
  "colContent": "عدد المحتوى",
  "colCreated": "تاريخ الإنشاء",
  "newGroup": "مجموعة جديدة",
  "title": "المجموعات",
  "intro": "المحتوى المنشور على مجموعة مشغلات يُعرض على كل مشغل فيها. ويحصل المشغل على محتوى المجموعة تلقائيًا.",
  "searchLabel": "البحث في مجموعات المشغلات",
  "searchPh": "البحث في المجموعات أو الوسوم",
  "manage": "إدارة مجموعة المشغلات",
  "clearSearch": "مسح البحث",
  "noGroups": "لا توجد مجموعات مشغلات بعد",
  "emptyHint": "سهّل النشر بتجميع مشغلاتك، مثل كل شاشات الاستقبال. يمكن أن يكون المشغل في عدة مجموعات.",
  "drawerDesc": "تعرض مشغلات المجموعة المحتوى المنشور عليها.",
  "name": "الاسم",
  "namePh": "مثل: مشغلات الاستقبال",
  "nextHint": "بعد ذلك يمكنك إضافة مشغلات ونشر محتوى عليها.",
  "rename": "إعادة تسمية",
  "noMembers": "لا توجد مشغلات في هذه المجموعة بعد.",
  "noCoords": "بلا إحداثيات",
  "located": "محدد الموقع",
  "addPlayers": "إضافة مشغلات",
  "allIn": "كل المشغلات في هذه المجموعة بالفعل. أضف مشغلات أخرى في صفحة",
  "notInGroup": "المشغلات غير الموجودة في هذه المجموعة",
  "saveTags": "حفظ الوسوم",
  "cancel": "إلغاء",
  "tagsHint": "يُعدّ الأعضاء حاملين لهذه الوسوم (النشر ← الوسوم، القيود).",
  "deleteGroup": "حذف مجموعة المشغلات",
  "deleteHint": "تغادر مشغلاتها المجموعة ويُزال محتواها المنشور منها.",
  "createGroup": "إنشاء مجموعة",
  "creating": "جارٍ الإنشاء…"
};
export default { en, ar };
